export function getRedirectPath(perfil: string, cargo?: string): string {
  if (perfil === 'ESCOLA' && (cargo === 'COORDENACAO' || cargo === 'SECRETARIA')) {
    return '/equipe/dashboard';
  }
  switch (perfil) {
    case 'ADMIN':
      return '/master/dashboard';
    case 'ESCOLA':
      return '/admin/dashboard';
    case 'PROFESSOR':
      return '/professor/dashboard';
    case 'RESPONSAVEL':
      return '/responsavel/dashboard';
    case 'ALUNO':
      return '/aluno/dashboard';
    case 'MUNICIPAL':
      return '/municipal/dashboard';
    case 'ESTADUAL':
      return '/estadual/dashboard';
    case 'REDE':
      return '/rede/dashboard';
    case 'PUBLICO':
      return '/public/dashboard';
    default:
      return '/admin/dashboard';
  }
}
